export default __webpack_public_path__ + "static/media/return.5d1f29c0.svg";